export const MIN_COLOR_VAL_NAME_ID = 'MIN_COLOR_VAL';
export const MAX_COLOR_VAL_NAME_ID = 'MAX_COLOR_VAL';
export const SIMPLE_COLOR_VAL_NAME_ID = 'SIMPLE_COLOR_VAL';
export const NEUTRAL_COLOR_VAL_NAME_ID = 'NEUTRAL_COLOR_VAL';
export const OVERLAY_OPACITY_NAME_ID = 'OVERLAY_OPACITY';
export const SEARCH_DISTANCE_NAME_ID = 'SEARCH_DISTANCE';
export const REQUEST_ACCOUNT_EMAIL = 'REQUEST_ACCOUNT_EMAIL';
export const TERMS_OF_SERVICE_ID = 'TERMS_OF_USE';
export const MATOMO_URL = 'MATOMO_URL';
export const COOKIE_POLICY_URL = 'COOKIE_POLICY_URL';
export const LEFT_LOGO_IMG = 'LEFT_LOGO_IMG';
export const LEFT_LOGO_LINK = 'LEFT_LOGO_LINK';
export const LEFT_LOGO_TEXT = 'LEFT_LOGO_TEXT';
export const RIGHT_LOGO_IMG = 'RIGHT_LOGO_IMG';
export const RIGHT_LOGO_LINK = 'RIGHT_LOGO_LINK';
export const RIGHT_LOGO_TEXT = 'RIGHT_LOGO_TEXT';
export const MINERVA_ROOT = 'MINERVA_ROOT';

export const MCP_ENABLED = 'MCP_ENABLED';
export const EMAIL_ADDRESS = 'EMAIL_ADDRESS';
export const EMAIL_LOGIN = 'EMAIL_LOGIN';
export const EMAIL_PASSWORD = 'EMAIL_PASSWORD';
export const EMAIL_SMTP_SERVER = 'EMAIL_SMTP_SERVER';
export const EMAIL_SSL_SERVER = 'EMAIL_SSL_SERVER';
export const EMAIL_SMTP_PORT = 'EMAIL_SMTP_PORT';
export const MINERVANET_URL = 'MINERVANET_URL';
export const MINERVANET_AUTH_TOKEN = 'MINERVANET_AUTH_TOKEN';
export const DEFAULT_MAP = 'DEFAULT_MAP';
export const X_FRAME_DOMAIN = 'X_FRAME_DOMAIN';
export const CORS_DOMAIN = 'CORS_DOMAIN';
export const BIG_FILE_STORAGE_DIR = 'BIG_FILE_STORAGE_DIR';
export const REQUEST_ACCOUNT_DEFAULT_CONTENT = 'REQUEST_ACCOUNT_DEFAULT_CONTENT';
export const SESSION_LENGTH = 'SESSION_LENGTH';
export const REQUEST_ACCOUNT_DEFAULT_TITLE = 'REQUEST_ACCOUNT_DEFAULT_TITLE';
export const ORCID_CLIENT_ID = 'ORCID_CLIENT_ID';
export const ORCID_CLIENT_SECRET = 'ORCID_CLIENT_SECRET';
export const ALLOW_AUTO_REGISTER = 'ALLOW_AUTO_REGISTER';
export const REQUIRE_APPROVAL_FOR_AUTO_REGISTERED_USERS =
  'REQUIRE_APPROVAL_FOR_AUTO_REGISTERED_USERS';

export const LDAP_ADDRESS = 'LDAP_ADDRESS';
export const LDAP_PORT = 'LDAP_PORT';
export const LDAP_SSL = 'LDAP_SSL';
export const LDAP_BIND_DN = 'LDAP_BIND_DN';
export const LDAP_PASSWORD = 'LDAP_PASSWORD';
export const LDAP_BASE_DN = 'LDAP_BASE_DN';
export const LDAP_OBJECT_CLASS = 'LDAP_OBJECT_CLASS';
export const LDAP_FIRST_NAME_ATTRIBUTE = 'LDAP_FIRST_NAME_ATTRIBUTE';
export const LDAP_LAST_NAME_ATTRIBUTE = 'LDAP_LAST_NAME_ATTRIBUTE';
export const LDAP_EMAIL_ATTRIBUTE = 'LDAP_EMAIL_ATTRIBUTE';
export const LDAP_FILTER = 'LDAP_FILTER';
export const LDAP_UID = 'LDAP_UID';

export const LEGEND_FILE_1 = 'LEGEND_FILE_1';
export const LEGEND_FILE_2 = 'LEGEND_FILE_2';
export const LEGEND_FILE_3 = 'LEGEND_FILE_3';
export const LEGEND_FILE_4 = 'LEGEND_FILE_4';

export const LEGEND_FILE_NAMES_IDS = [LEGEND_FILE_1, LEGEND_FILE_2, LEGEND_FILE_3, LEGEND_FILE_4];

export const GPML_HANDLER_NAME_ID = 'GPML';
export const SBML_HANDLER_NAME_ID = 'SBML';
export const CELL_DESIGNER_SBML_HANDLER_NAME_ID = 'CellDesigner SBML';
export const SBGN_ML_HANDLER_NAME_ID = 'SBGN-ML';

export const PNG_IMAGE_HANDLER_NAME_ID = 'PNG image';
export const PDF_HANDLER_NAME_ID = 'PDF';
export const SVG_IMAGE_HANDLER_NAME_ID = 'SVG image';

export const CONFIGURATION_OPTIONS_FETCHING_ERROR_PREFIX = 'Failed to fetch configuration options';

export const CONFIGURATION_FETCHING_ERROR_PREFIX = 'Failed to fetch configuration';
